<div class="form-main-block">
    <div class="form-boxes">
        <app-accordion [expanded]="true" [showExpand]="false" [showTitle]="false">
            <ng-container *ngFor="let quest of questions;">
                <div class="form-box-block">
                    <div class="form-number">{{quest.Section}}.</div>
                    <div class="form-box">
                        <div class="form-detail">
                            <div class="form-title">
                                <span>{{quest.Question}}</span>
                            </div>
                            <div class="form-detail-block">
                                <ng-container *ngIf="quest.Visible">
                                    <div class="form-content">
                                        <ng-container *ngIf="quest.QuestionType===QuestionTypeEnum.ACTION">
                                            <ng-container *ngIf="quest.ValueType===ValueTypeEnum.OPTION">
                                                <div class="input-buttons">
                                                    <ng-container *ngFor="let item of quest.Options">
                                                        <button type="button" class="input-button" [class.selected]="quest.Note===item" (click)="selectOption(quest, item)">
                                                            <span>{{item}}</span>
                                                        </button>
                                                    </ng-container>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="quest.ValueType===ValueTypeEnum.INPUT">
                                                <div class="input-width mw-100">
                                                    <input type="text" class="form-control" [(ngModel)]="quest.Note" [attr.placeholder]="quest.Placeholder" />
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="quest.QuestionType===QuestionTypeEnum.INFO">
                                            <img class="mw-100" [src]="quest.Image" alt="{{quest.Image}}" />
                                        </ng-container>
                                    </div>

                                    <ng-container *ngIf="quest.Questions">
                                        <ng-container *ngFor="let subQuest of quest.Questions">
                                            <div class="form-questions" *ngIf="subQuest.Visible">
                                                <div class="form-content hide-border">
                                                    <div class="form-title">
                                                        <div class="form-title-left">
                                                            <span>{{subQuest.Question}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="question-expanded">
                                                        <ng-container *ngIf="subQuest.QuestionType===QuestionTypeEnum.ACTION">
                                                            <ng-container *ngIf="subQuest.ValueType===ValueTypeEnum.OPTION">
                                                                <div class="input-buttons">
                                                                    <ng-container *ngFor="let item of subQuest.Options">
                                                                        <button type="button" class="input-button" [class.selected]="subQuest.Note===item" (click)="selectOption(subQuest, item)">
                                                                            <span>{{item}}</span>
                                                                        </button>
                                                                    </ng-container>
                                                                </div>
                                                            </ng-container>
                                                            <ng-container *ngIf="subQuest.ValueType===ValueTypeEnum.INPUT">
                                                                <div class="input-width mw-100">
                                                                    <input type="text" class="form-control" [(ngModel)]="subQuest.Note" [attr.placeholder]="subQuest.Placeholder" />
                                                                </div>
                                                            </ng-container>
                                                        </ng-container>
                                                        <ng-container *ngIf="subQuest.QuestionType===QuestionTypeEnum.INFO">
                                                            <img class="mw-100" [src]="subQuest.Image" alt="{{subQuest.Image}}" />
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </app-accordion>
    </div>
</div>
